import Feature from '../Home/Components/Feature'
import BanerSection from './Components/BanerSection'
import Formarea from './Components/Formarea'
import Offeringarea from './Components/Offeringarea'
import PricingSection from './Components/PricingSection'
import './Service.css'
const Service = () => {
  return (
    <div>
      <BanerSection/>
     <Feature/>
     <Offeringarea/>
     {/* <PricingSection/> */}
     <Formarea/>
    </div>
  )
}

export default Service